import Tag, { TagTone } from './ui/Tag';
import {
  AIRSPACE_STATUS_LABELS,
  AIRSPACE_STATUS_LABELS_SHORT,
  AirspaceStatus,
} from '../utils/airspace-helpers';

interface Props {
  status: AirspaceStatus | string | null | undefined;
  /**
   * 'table'  short label ("Auth"), the full one on hover.
   * 'full'   the full label ("Needs Auth").
   * 'inline' the full label at the small size, for a tag inside a line of text.
   */
  size?: 'table' | 'full' | 'inline';
  title?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const TONE: Record<AirspaceStatus, TagTone> = {
  needs_review: 'neutral',
  needs_authorization: 'warn',
  pending: 'info',
  complete: 'good',
  needs_action: 'bad',
};

/** Airspace status as a kit Tag. Needs action breathes until someone takes it. */
const AirspaceStatusPill: React.FC<Props> = ({ status, size = 'table', title, onClick }) => {
  const s = (status || 'needs_review') as AirspaceStatus;
  const label = size === 'table'
    ? (AIRSPACE_STATUS_LABELS_SHORT[s] || String(status))
    : (AIRSPACE_STATUS_LABELS[s] || String(status));

  return (
    <Tag
      tone={TONE[s] || 'neutral'}
      size={size === 'inline' ? 'sm' : 'md'}
      attention={s === 'needs_action'}
      title={title || AIRSPACE_STATUS_LABELS[s]}
      onClick={onClick}
      aria-label={onClick ? title || AIRSPACE_STATUS_LABELS[s] : undefined}
    >
      {label}
    </Tag>
  );
};

export default AirspaceStatusPill;
